"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateProfile = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const identity_1 = require("../../identity");
const ResponseBase_1 = require("../../ResponseBase");
var UpdateProfile;
(function (UpdateProfile) {
    class Request extends ResponseBase_1.ResponseBase {
    }
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsUUID)(),
        (0, tslib_1.__metadata)("design:type", String)
    ], Request.prototype, "memberId", void 0);
    (0, tslib_1.__decorate)([
        designed_1.Entity.Field(),
        (0, class_validator_1.IsInstance)(identity_1.UpdateUserProfile),
        (0, tslib_1.__metadata)("design:type", identity_1.UpdateUserProfile)
    ], Request.prototype, "updates", void 0);
    UpdateProfile.Request = Request;
})(UpdateProfile = exports.UpdateProfile || (exports.UpdateProfile = {}));
